module.exports = __webpack_public_path__ + "./docs/img/kit-http-api.051b4e102de890b9f6809169449b148e.svg";